import { StatsigClient } from '@statsig/react-bindings'

import { STATSIG_GATE_NAMES } from './use-statsig-gate.hook'

/**
 * Non-hook read of the `vda_order_change_enabled` gate, for module-level code that runs outside
 * React — `getLineItemDetails` in the cart helpers builds each item's `productLink` query params
 * from the variant title's segments and has no React context to read a hook from.
 *
 * Browser-only, and any Statsig failure resolves to `false` so a client error can never change a
 * link. Unlike `getSvdExperimentValue` this has no webview branch and no `ENABLE_SVD_FLOW_DISCOVERY`
 * kill switch: the gate is a correctness fix, not part of the SVD rollout, so killing SVD must not
 * restore the wrong colour/size ordering.
 */
export const getVdaOrderChangeGateValue = (): boolean => {
  if (typeof window === 'undefined') return false
  try {
    return StatsigClient.instance().checkGate(STATSIG_GATE_NAMES.VDA_ORDER_CHANGE_ENABLED)
  } catch (error) {
    console.error('Failed while checking the vda_order_change_enabled gate outside React', error)
    return false
  }
}
